import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { FormComponent, LocaleService, ProvincesStatesCodesService, TimezoneService } from '@tdwb/core';
import { AgreementsDateBaseDirective } from '../agreements.base';

export interface OpraAgreementFormModel {
  clientFirstName: string,
  clientLastName: string,
  addressLine1: string,
  addressLine2: string,
  city: string,
  provinceState: string,
  postalCode: string
}
@Component({
  selector: 'td-wb-opra-agreement',
  templateUrl: './opra-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class OpraAgreementComponent extends AgreementsDateBaseDirective {

  @ViewChild(FormComponent) form: FormComponent;
  @ViewChild('btn') btn: ElementRef;

  provinceStatesCodesService: ProvincesStatesCodesService;

  formModel: OpraAgreementFormModel = {
    clientFirstName: '',
    clientLastName: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    provinceState: '',
    postalCode: ''
  };

  constructor(provinceStatesCodesService: ProvincesStatesCodesService,
              timezoneService: TimezoneService,
              localeService: LocaleService) {
    super(timezoneService, localeService);
    this.provinceStatesCodesService = provinceStatesCodesService;
  }

  trySubmitAndReturnModel(): OpraAgreementFormModel {
    return super.trySubmit(this.form) ? this.formModel : undefined;
  }

}
